const normalizeOutput = (value) => String(value || '')
	.replace(/\r\n/g, '\n')
	.replace(/\n{3,}/g, '\n\n')
	.trim();

const extractNodeText = (node) => {
	if (!node) return '';
	if (typeof node === 'string') return node;
	if (typeof node !== 'object') return '';

	if (node.type === 'hardBreak') return '\n';
	if (node.type === 'horizontalRule') return '\n---\n';
	if (typeof node.text === 'string') return node.text;

	const children = Array.isArray(node.content)
		? node.content.map((child) => extractNodeText(child)).filter(Boolean)
		: [];

	const inlineJoined = children.join('');

	if (['paragraph', 'heading', 'listItem', 'taskItem', 'blockquote', 'codeBlock'].includes(node.type)) {
		return `${inlineJoined}\n`;
	}

	if (['doc', 'bulletList', 'orderedList', 'taskList'].includes(node.type)) {
		return children.join('\n');
	}

	return inlineJoined;
};

export const extractPlainTextFromTipTap = (doc) => {
	if (!doc || typeof doc !== 'object') return '';
	return normalizeOutput(extractNodeText(doc));
};

export default extractPlainTextFromTipTap;
